export default __webpack_public_path__ + "static/media/typehus.5a04f554.svg";